export default class ShowSubstitutionController {
  /** @ngInject */
  constructor(
    $log, $mdDialog,
    moment,
    SubstitutionService,
    UtilService,
    substituteActivitie
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.moment = moment;
    this.SubstitutionService = SubstitutionService;
    this.UtilService = UtilService;
    this.substituteActivitie = substituteActivitie;

    this.date = this.moment(this.substituteActivitie.date).toDate();
    if (this.substituteActivitie.startTime) {
      this.startTime = this.moment(this.UtilService.parseTime(this.substituteActivitie.startTime)).format('HH:mm');
    }

    if (this.substituteActivitie.endTime) {
      this.endTime = this.moment(this.UtilService.parseTime(this.substituteActivitie.endTime)).format('HH:mm');
    }
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
